import {
  ApolloCache,
  ApolloClient,
  ApolloLink,
  NormalizedCacheObject,
} from "@apollo/client";

import cookie from "js-cookie";
import { createUploadLink } from "apollo-upload-client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";

const emptyCacheObj = {};
export class VoidCache extends ApolloCache<NormalizedCacheObject> {
  read(options) {
    return null;
  }
  write(options) {
    return undefined;
  }
  diff(options) {
    return {};
  }
  watch(watch) {
    return () => { }; // eslint-disable-line
  }
  async reset() { } // eslint-disable-line
  evict(options) {
    return false;
  }
  restore(data) {
    return this;
  }
  extract(optimistic) {
    return emptyCacheObj;
  }
  removeOptimistic(id) { } // eslint-disable-line
  batch(options) {
    return undefined as any;
  }
  performTransaction(update, optimisticId) { } // eslint-disable-line
  recordOptimisticTransaction(transaction, optimisticId) { } // eslint-disable-line
  transformDocument(document) {
    return document;
  }
  transformForLink(document) {
    return document;
  }
  identify(object) {
    return undefined;
  }
  gc() {
    return [] as string[];
  }
  modify(options) {
    return false;
  }
  readQuery(options, optimistic?) {
    return null;
  }
  readFragment(options, optimistic?) {
    return null;
  }
  writeQuery(opts) {
    return undefined;
  }
  writeFragment(opts) {
    return undefined;
  }
  updateQuery(options, update) {
    return null;
  }
  updateFragment(options, update) {
    return null;
  }
}

const headerLink = setContext(async (_, { headers }) => {
  try {
    const token = cookie.get("access_token");
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : "",
      },
    };
  } catch (error) {
    console.log(error);
  }
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    console.dir(graphQLErrors?.[0]?.message.includes('Not Authorised!'));

    if (graphQLErrors?.[0]?.message.includes('Not Authorised!')) {
      document.cookie = "";
      localStorage.removeItem("user");
      window.location.href = '/#/login';
    }

    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.error(`[Network error]: ${networkError}`);
});

const createApolloClient = (endpoint: string): ApolloClient<unknown> => {
  console.log(`Connecting to ${endpoint}`);

  return new ApolloClient({
    link: ApolloLink.from([
      headerLink,
      errorLink,
      createUploadLink({ uri: endpoint }) as any,
    ]),
    cache: new VoidCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    },
  });
};
export default createApolloClient;
